import { CheckoutHeading } from './styledComponents';

export const CheckoutTitle = ({ children, ...props }) => {
  return <CheckoutHeading {...props}>{children}</CheckoutHeading>;
};
